module.exports = __webpack_public_path__ + "img/effortless-sleep.8b36f64b.png";